import { Outlet } from "react-router-dom";
import { NavigationProgress } from "@/components/animations/NavigationProgress";
import CookieConsent from "@/components/CookieConsent";

export function RootLayout() {
  return (
    <>
      <NavigationProgress />
      <CookieConsent />
      <Outlet />
    </>
  );
}
